"use strict";
exports.__esModule = true;
var table_selector_1 = require("../logic/table-selector");
var angular = require("angular");
var rearrangedChosenList = [];
angular.module('smartorg.r6.cmpts.tableSelector').directive('tableSelector', [function () {
        return {
            restrict: 'E',
            template: require('../../template/table-selector.html'),
            scope: {
                /**
                 * Title of list. Example: Templates, Groups, Input Fields.
                 */
                title: '@?',
                /**
                 * Label to show on excluded items. Example: Not Chosen, Excluded.
                 */
                excludedLabel: '@?',
                /**
                 * Label to show on included items. Example: Chosen, Included.
                 */
                includedLabel: '@?',
                /**
                 * Data needed for displaying the lists. Including:
                 * chosen: included items;
                 * notChosen: excluded items;
                 * fixedChosen: items that always in chosen list;
                 * fixedNotChosen: items that always in notChosen list.
                 */
                data: '=',
                /**
                 * This function is defined in directive. Container which use
                 * the directive call this function.
                 *
                 * Example:
                 * <list-selector init="someFunction"></list-selector>
                 * In container, call someFunction() when needed. This will
                 * acturally call this init function in this directive. If
                 * multiple directive instances are put in a same page, make
                 * sure different someFunction names are assigned to each
                 * instance, in order not to mess with the other ones.
                 */
                init: '=',
                /**
                 * Means something have been changed, should enable the save
                 * button/function.
                 */
                saveEnabled: '=?',
                /**
                 * Show search input or not. Only 'true' shows.
                 */
                searchEnabled: '@?',
                /**
                 * Must choose at least (input) before going to next step.
                 * Default is 0.
                 */
                atLeast: '@?'
            },
            link: function (scope) {
                /**
                 * Initialize the value, undefined will result in nothing
                 * display.
                 *
                 * @type {string}
                 */
                scope.searchKey = '';
                /**
                 * Set default values in nothing passed in.
                 */
                if (!scope.excludedLabel) {
                    scope.excludedLabel = "Not Chosen";
                }
                if (!scope.includedLabel) {
                    scope.includedLabel = "Chosen";
                }
                scope.atLeastNumber = parseInt(scope.atLeast) | 0;
                scope.showArrangePage = false;
                rearrangedChosenList = [];
                /**
                 * This function should be called after loading all data.
                 * It works the opposite way as normal, container calls
                 * directive function in this case.
                 *
                 * The reason of doing things like this is to avoid using
                 * complex broadcast because broadcasting may result in
                 * some strange error if we have two or more items in the
                 * same page.
                 */
                scope.init = function () {
                    if (!scope.data) {
                        scope.data = {};
                    }
                    scope.selector = new table_selector_1["default"].TableSelector(scope.data.rowHeaders, scope.data.colHeaders);
                    // If there is an initial chosen list, put it in.
                    if (scope.data.chosen) {
                        scope.selector.addToChosen(scope.data.chosen);
                    }
                    scope.showArrangePage = false;
                };
                /**
                 * Use angular filter as search function.
                 *
                 * @param item
                 * @returns {boolean}
                 */
                scope.listFilter = function (item) {
                    if (scope.searchEnabled && scope.searchEnabled === 'true'
                        && typeof item === "string") {
                        return item.toLowerCase().indexOf(scope.searchKey.toLowerCase()) >= 0;
                    }
                    else {
                        return true;
                    }
                };
                scope.funcs = {
                    addAll: function () {
                        scope.selector.addAll(scope.searchKey);
                        scope.funcs.updateData();
                    },
                    addToChosen: function () {
                        scope.selector.addCellsToChosen(scope.tselectRow, scope.tselectCol);
                        scope.funcs.updateData();
                    },
                    removeFromChosen: function () {
                        scope.selector.removeFromChosen(scope.tselect1);
                        scope.funcs.updateData();
                    },
                    removeAll: function () {
                        scope.selector.removeAll();
                        scope.funcs.updateData();
                    },
                    updateData: function () {
                        scope.data.chosen = scope.selector.getChosenList();
                        scope.data.notChosen = scope.selector.getNotChosenList();
                        scope.saveEnabled = scope.selector.hasChanged();
                    }
                };
                scope.arrangeChosenList = function () {
                    scope.showArrangePage = true;
                    rearrangedChosenList = [];
                };
                scope.finishArranging = function () {
                    scope.showArrangePage = false;
                    if (rearrangedChosenList.length > 0) {
                        scope.data.chosen = rearrangedChosenList;
                        scope.selector['chosen'] = rearrangedChosenList;
                        // scope.selector = new listSelectorLogic.ListSelector(
                        //     scope.data.chosen, scope.data.notChosen,
                        //     scope.data.fixedChosen, scope.data.fixedNotChosen);
                        scope.funcs.updateData();
                    }
                };
                /**
                 * Necessary for sorting chosen list.
                 */
                $(function () {
                    angular.element("#arrangeChosenTableInputFields").sortable({
                        placeholder: "treeview-sort-placeholder",
                        stop: function (event, ui) {
                            arrange("#arrangeChosenTableInputFields");
                        }
                    });
                });
                $(function () {
                    angular.element("#arrangeChosenTableOutputFields").sortable({
                        placeholder: "treeview-sort-placeholder",
                        stop: function (event, ui) {
                            arrange("#arrangeChosenTableOutputFields");
                        }
                    });
                });
                function arrange(element) {
                    var rearrangedChosenListStr = angular.element(element).sortable("toArray");
                    rearrangedChosenList = [];
                    rearrangedChosenListStr.forEach(function (str) {
                        rearrangedChosenList.push(JSON.parse(str));
                    });
                    setTimeout(function () {
                        scope.$apply();
                    }, 0);
                }
            }
        };
    }]);
//# sourceMappingURL=table-selector-directive.js.map


// WEBPACK FOOTER //
// ./app/components/table-selector/app/js/plumbing/table-selector-directive.js